import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import Vuetify, { VAlert, VApp, VNavigationDrawer, VFooter, VList, VBtn, VIcon, VToolbar, VDataTable, VProgressLinear } from 'vuetify/lib'

// vue-cli a-la-carte installation
Vue.use(Vuetify, {
  components: {
    VAlert,
    VApp,
    VNavigationDrawer,
    VFooter,
    VList,
    VBtn,
    VIcon,
    VToolbar,
    VDataTable,
    VProgressLinear,
  },
})

const opts = {
  theme: {
    themes: {
      light: {
        primary: '#607d8b',
        secondary: '#607d8b',
        accent: '#3f51b5',
        error: '#f44336',
        warning: '#ff5722',
        info: '#2196f3',
        success: '#4caf50',
      },
      originallight: {
        primary: '#1976D2',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
      },
    },
  },
}

export default new Vuetify(opts)
